import { useLocation } from "react-router-dom";

export function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export function omitReduxProps(props = {}) {
    const clonedObject = Object.assign({}, props)
    delete clonedObject.history
    delete clonedObject.location
    delete clonedObject.match
    delete clonedObject.staticContext
    delete clonedObject.dispatch

    return clonedObject
}

export function isUnauthenticated(error) {
    const status = (error?.response && error?.response?.status) ? error.response.status : null;
    const unauthorizedErrors = ["The user is not authenticated", "No current user", "Request failed with status code 401"];
    
    return unauthorizedErrors.includes(error) || status === 401
}

export function isValidId(userId) { return isIdmuid(userId) || isEmplid(userId) || isNameN(userId); }
export function isIdmuid(userId) { return /^IDM\d+$/i.test(userId); } // idm123456 only
export function isEmplid(userId) { return /^\d{8,9}$/.test(userId); } // Numbers only
export function isNameN(userId) {
    return /^[A-Za-z-]+\.\d+$/.test(userId); // abc.123 only // changing slightly to allow build to work (es lint error)
  }

export function isValidPassword(s) { return typeof s === "string" && s.trim()?.length >= 5; } // TODO Validate this is okay

export function safeString(o) { return typeof o === "string" ? o : JSON.stringify(o); }